import { useEffect, useRef, useState } from 'react';
import { useSetAtom } from 'jotai';
import { Store } from 'jotai/vanilla/store';
import { addNotificationAtom } from '@/store/notifications';

const CONNECTION_CHECK_INTERVAL = 5;

const useSlowInternetNotification = ({ store }: { store: Store }) => {
  const timerRef = useRef<NodeJS.Timer>();
  const addNotification = useSetAtom(addNotificationAtom, { store });
  const [isNotificationShown, setIsNotificationShown] = useState(false);

  const checkConnection = () => {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!connection) return;

    if (connection.downlink < 0.4) {
      addNotification({ id: 'slow_internet', content: 'У вас медленное соединение! Некоторые функции могут работать неправильно.', type: 'ERROR' });
      setIsNotificationShown(true);
    }
  };

  useEffect(() => {
    if (!isNotificationShown) timerRef.current = setInterval(checkConnection, CONNECTION_CHECK_INTERVAL * 1000);
    return () => clearInterval(timerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNotificationShown]);
};

export default useSlowInternetNotification;
